module.exports = __webpack_public_path__ + "static/media/impressao_digital.41b602df.jpg";